import script from "./MemberGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberGallery.vue?vue&type=script&setup=true&lang=js"

import "./MemberGallery.vue?vue&type=style&index=0&id=7a6a1596&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a6a1596"]])

export default __exports__